import { AxiosError } from 'axios'
import { action, flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers'

import { UrlParams } from 'Portals/Customer/constants'
import { Wastestream } from 'Portals/Customer/entities'
import {
	filtersConfig,
	refCodeSearchConfig,
	searchConfig,
	supplierLocationSearchConfig
} from 'Portals/Customer/Pages/Wastestream/TableList/Filters/utils/config'
import { WastestreamRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_WASTESTREAM_PAGE_SIZE = storagePageSizeConstant('wastestream')

export class WastestreamTable extends TableStore<Wastestream.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_WASTESTREAM_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: WastestreamRepo.getList,
				defaultSort
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@action.bound
	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.id, UrlParams.name, UrlParams.serviceSiteName, UrlParams.refCode, UrlParams.supplierLocationName, CoreUrlParams.searchQuery]
		const filterKeys = [UrlParams.serviceSiteId, UrlParams.refCodeFilter, UrlParams.supplierLocationName]

		const mergedSearchConfig = {
			...searchConfig,
			...refCodeSearchConfig,
			...supplierLocationSearchConfig,
			...searchQueryConfig
		}
		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, filtersConfig)
	}

	reset = () => {
		this.resetTable()
	}
}
